import React from "react";
import SearchResultPage from "./search-results-template";
import { useGlobalStore } from "@store/globalStore";

const SsgSearchResultsTemplate = (props) => {
    const currencyType = useGlobalStore((state) => state.currencyType);

    const {
        locationname,
        pcategorytype,
        ptype,
        ptypetag,
        pstatustype,
        completionstatus,
        fullpathname
    } = props.pageContext;

    const pathname = typeof window !== "undefined"
        ? window.location.pathname
        : (props.location?.pathname || fullpathname);
    const location = { pathname };

    return (
        <React.Fragment>
            <SearchResultPage
                {...props}
                locationname={locationname}
                pcategorytype={pcategorytype}
                ptype={ptype}
                ptypetag={ptypetag}
                pstatustype={pstatustype}
                completionstatus={completionstatus}
                fullpathone={location}
                fullpathname={pathname}
                currencyType={currencyType}
                location={location}
            />
        </React.Fragment>
    );
};

export default SsgSearchResultsTemplate;
